import { fullAccessLevels, halfAccessLevels } from '../accessLevels';
import ActionTypes from '../actions/types';
import momentz from 'moment-timezone';

const queryParams = new URLSearchParams(window.location.search);

/**
 * @type {import('../typings').IStateReducerState}
 */

const initialState = {
  showVideo: false,
  localTicker: '',
  type: 'calls',
  from: '',
  to: '',
  fromValue: 0,
  toValue: 99999999,
  arrowPosition: 0,
  arrowPositionModal: 0,
  callsLimit: 99999999,
  putsLimit: 99999999,
  percent: 0,
  dates: [],
  showChart: false,
  putsChartData: [],
  callsChartData: [],
  modalStrikes: [],
  step: 1,
  max: 1,
  openError: false,
  activeRow: {},
  isOIchecked: false,
  modalRowData: [],
  expiration: [],
  selectedDate: momentz
    .tz(new Date(), 'America/New_York')
    .format('YYYY-MM-DD'),
  earningToolTip: '',
  exToolTip: '',
  holderModal: false,
};

const levels = queryParams.get('levels');

if (levels) {
  const splitedLevels = levels.split(',');
  const fullAccess = splitedLevels.some((mem) =>
    fullAccessLevels.includes(mem)
  );
  const halfAccess = splitedLevels.some((mem) =>
    halfAccessLevels.includes(mem)
  );

  if (fullAccess && Object.keys(fullAccess).length) {
    initialState.accessLevel = 'fullaccess';
    initialState.redirectLink = '/home';
  } else if (halfAccess && Object.keys(halfAccess).length) {
    initialState.accessLevel = 'halfaccess';
    initialState.redirectLink = '/unusualoptionsactivity';
  } else {
    console.log('no case found');
    initialState.redirectLink = '/unusualoptionsactivity';
    // window.location.replace("https://optionsgeek.com/welcome-home-page");
  }
}

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case ActionTypes.SET_OPEN_INTREST:
      return {
        ...state,
        ...payload,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/openInterestState.js